/*
 * Wraps SATComponent.prototype.renderVals to strip fabricated, checkable
 * facts out of the Front Counter info cards (Home footer → Contact /
 * Returns & Claims / Trade Accounts / Track An Order). Originally this
 * patch only dropped the fake "(760) 555-0114" landline from the Contact
 * card; auditing the rest of these cards at the merchant's request turned
 * up the same problem spread across three more of them — a street address
 * ("Counter 9 ... Mammoth Lakes CA 93546"), fixed hours, a 14-day return
 * window, "NET 45" trade credit terms, a $2,500 trade minimum, a specific
 * transit time — none of which trace back to anything real about this
 * store. A customer relying on any of it (timing a return around a
 * window that doesn't exist, mailing a letter to an address nobody reads)
 * gets burned by a made-up fact reading as a stated policy.
 *
 * Kept, deliberately: the "sourcing" card (auction/depot/estate copy) and
 * everything in Track An Order that describes how the SAT-#### order
 * number itself works — both are either pure narrative voice or actually
 * true (see snippets/sat-bootstrap.liquid's real SAT-#### generation and
 * this.submitClearance()'s real use of that same number as a clearance
 * code). Only the fabricated specifics come out; the site's voice stays.
 *
 * Kept as a small patch instead of edited into sat-app.js directly: that
 * asset is large enough that a direct edit is slow and risky to deploy
 * reliably, and this build's whole pattern is to layer small, targeted
 * patches over the ported base file rather than touch it in place. See
 * assets/sat-import-pager-patch.js and assets/sat-home-featured-patch.js
 * for the same approach elsewhere in this theme.
 */
(function () {
  'use strict';
  if (!window.SATComponent) { return; }

  var CARDS = {
    contact: {
      lines: [
        'The counter keeps its own hours. Reach it when you reach it.',
        'Written enquiries are answered in the order they arrive, which is not the order they were sent.'
      ],
      rows: [
        ['Reply time', 'NO PROMISES']
      ]
    },
    returns: {
      lines: [
        'Photograph anything materially different from its listing before you unpack it further — the photograph settles most claims in your favor.',
        'Wear, patina, faded stencils, and honest age are not faults. They are the reason the price is what it is.',
        'We do not haggle.'
      ],
      rows: [
        ['Excludes', 'WEAR · AGE · PATINA']
      ]
    },
    trade: {
      lines: [
        'Volume terms for production houses, museums, and dealers moving pallets rather than pieces.',
        'Trade accounts see the restricted index without a clearance code.',
        'Reach out through Contact to start the conversation.'
      ],
      rows: [
        ['For', 'DEPOTS · FILM · MUSEUMS'],
        ['Includes', 'RESTRICTED INDEX']
      ]
    },
    track: {
      lines: [
        'Every filed order gets a SAT number. Quote it and a clerk will read you the last line of the movement log.',
        'Your order number is also your clearance code for the restricted index. Keep it.'
      ],
      rows: [
        ['Reference', 'YOUR SAT‑#### NUMBER'],
        ['Also unlocks', 'RESTRICTED INDEX']
      ]
    }
  };

  var orig = window.SATComponent.prototype.renderVals;
  window.SATComponent.prototype.renderVals = function () {
    var out = orig.call(this);
    var s = this.state;
    var card = CARDS[s.counterKey];

    // out.counterLines/out.counterRows only exist on pages that render the
    // counter-info overlay, and only reflect whichever card is currently
    // open (s.counterKey). "sourcing" isn't in CARDS above, so it falls
    // through untouched and keeps sat-app.js's own copy.
    if (card) {
      out.counterLines = card.lines.map(function (t) { return { t: t }; });
      out.counterRows = card.rows.map(function (r) { return { k: r[0], v: r[1] }; });
    }

    return out;
  };
})();
